export interface ProjectLink {
  name: string;
  url: string;
}

/** Explicit project lifecycle, set by hand. A null status reads as 'ACTIVE'. */
export type ProjectStatus = 'ACTIVE' | 'STANDBY' | 'DONE' | 'ARCHIVED';

/** The statuses as offered in a picker, in the order they should be listed. */
export const PROJECT_STATUS_OPTIONS: { value: ProjectStatus; label: string }[] = [
  { value: 'ACTIVE', label: 'In progress' },
  { value: 'STANDBY', label: 'Stand-by' },
  { value: 'DONE', label: 'Done' },
  { value: 'ARCHIVED', label: 'Archived' },
];

export interface Project {
  projectId?: string,
  startDate?: string,
  projectName: string,
  estimatedHours?: number,
  status?: ProjectStatus | null,
  archivedAt?: string | null,
  tenantId: string,
  links?: ProjectLink[],
  order?: number,
  tenant?: {
    id: string;
    name: string;
  },
  managers?: ProjectManager[];
  members?: ProjectMember[];
  clientId?: string;
  client?: {
    id: string;
    name: string;
  };
}

export interface ProjectManager {
  id?: string;
  projectId: string;
  userId: string;
  user?: {
    id: string;
    name: string;
    firstName?: string;
    email?: string;
    isArchived?: boolean | null;
  };
  project?: {
    id: string;
    projectName: string;
  };
}

export interface ProjectMember {
  id?: string;
  projectId: string;
  userId: string;
  user?: {
    id: string;
    name: string;
    firstName?: string;
    email?: string;
    isArchived?: boolean | null;
  };
  project?: {
    id: string;
    projectName: string;
  };
}

export interface ProjectStage {
  projectStageId?: string,
  startDate: string,
  endDate: string,
  stageName: string,
  color: string,
  status: "NOTBEGIN" | "INPROGRESS" | "DONE" | null,
  projectId: string,
  order?: number,
  links?: ProjectLink[],
  estimatedHours?: number,
}

export interface GanttStageView {
  id: string;
  realId: string;
  title: string;
  color?: string;
  start: Date;
  end: Date;
  completionRatio: number;
  status: string;
  isStage: boolean;
  estimatedHours?: number;
  encodedHours?: number;
  expanded?: boolean;
  subtasks?: GanttStageView[];
}

export interface Phase {
  id?: string;
  name: string;
  links?: ProjectLink[];
  color: string;
  order?: number;
  estimatedHours?: number;
}

export interface PhaseModel {
  id?: string;
  modelName: string;
  phases: Phase[];
}

export interface EntryFilter {
  employeeId?: string;
  startDate?: string;
  endDate?: string;
  approvalStatus?: string;
  projectName?: string;           // legacy single filter (contains)
  projectNames?: string[];        // legacy multi-select: exact eq per raw projectName
  projectIds?: string[];          // filter by projectId (exact eq, most reliable)
  baseProjectNames?: string[];    // fallback for old entries without projectId (beginsWith)
  crmTaskNames?: string[];        // match CRM tasks via exact eq on "[Task] ..."
  projectId?: string;             // single projectId filter (exact match)
}

